var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCounterClockwiseRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12876_100332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49902 6.1875V10.0629H8.37447",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01841 17.1667C9.034 18.1252 10.3095 18.7631 11.6856 19.0008C13.0617 19.2385 14.4773 19.0654 15.7556 18.5032C17.0338 17.941 18.1181 17.0145 18.8728 15.8396C19.6276 14.6647 20.0194 13.2934 19.9992 11.8971C19.9791 10.5008 19.548 9.14136 18.7596 7.98869C17.9713 6.83602 16.8608 5.94121 15.5669 5.41606C14.2729 4.89092 12.8529 4.75872 11.4842 5.036C10.1156 5.31328 8.859 5.98773 7.87147 6.97508L4.49902 10.0617",
    stroke: "#24282F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12876_100332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCounterClockwiseRetry);
export default __webpack_public_path__ + "static/media/ArrowCounterClockwiseRetry.9d2c638a8d673277cf74c2b7bd12e145.svg";
export { ForwardRef as ReactComponent };